import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import Pagination from "../Common/Pagination/Pagination";
import CountUp from "react-countup";
import { useReactToPrint } from "react-to-print";
import _ from "lodash";
const TripDispatchStatus = ({ selectedDate, companyDetails }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [companyId, setCompanyId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [status, setStatus] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [statusOrder, setStatusOrder] = useState([]);
  const [statusOrderLength, setStatusOrderLength] = useState(0);
  const [govtCountData, setGovtCountData] = useState([]);
  const [vehicle, setVehicle] = useState([]);
  const [selectVehicleId, setSelectVehicleId] = useState("");
  const [printIndex, setPrintIndex] = useState(null);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + statusOrderLength - 1, totalRecords);
  const componentPDFRefs = useRef([]);
  const bulkPDFRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => componentPDFRefs.current[printIndex],
    pageStyle: `
      @page {
        size: auto !important;
        margin: 2mm;
      }
      @media print {
        .print_btn {
          display: none !important;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ddd;
          border-spacing: 0;
          margin-bottom: 10px;
          transform: scale(0.9);
        }
        th, td {
          border: 1px solid #ddd;
          padding: 8px;
          min-width: 100% !important;
        }
        body {
          transform: scale(0.9);
        }
      }`,
    documentTitle: "Govt Supply Status",
    onAfterPrint: () => setPrintIndex(null),
  });

  const handlePrintBulk = useReactToPrint({
    content: () => bulkPDFRef.current,
    pageStyle: `
      @page {
        size: auto !important;
        margin: 2mm;
      }
      @media print {
        table {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ddd;
          border-spacing: 0;
          margin-bottom: 10px;
          transform: scale(0.95);
        }
        th, td {
          padding: 8px;
          border: 1px solid #ddd;
          min-width: 100% !important;
        }
        body {
          transform: scale(0.95);
        }
    }`,
    documentTitle: "Trip Dispatch Details",
    onAfterPrint: () => setPrintIndex(null),
  });

  const generatePDF = (index) => {
    setPrintIndex(index);
  };

  useEffect(() => {
    if (printIndex !== null) {
      handlePrint();
    }
  }, [printIndex]);

  const getVehicle = async () => {
    let BASE_URL =
      SERVER_URL + `/api/vehicle-details/all-vehicle-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setVehicle(result.data);
  };

  useEffect(() => {
    getVehicle();
  }, []);

  const getGovtOrderCount = async () => {
    const renewalDate = moment(selectedDate).format("YYYY-MM-DD");
    let BASE_URL = `${SERVER_URL}/api/trips/trips-count-status/${user_id}?date=${renewalDate}&vehicle_id=${selectVehicleId}&status=${status}&company_id=${companyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setGovtCountData(result.data);
    } else {
      setGovtCountData([]);
    }
  };
  // console.log(govtCountData);
  useEffect(() => {
    getGovtOrderCount();
  }, [companyId, selectedDate, status, selectVehicleId]);

  const handleCompanyChange = (e) => {
    setCompanyId(e.target.value);
  };
  const handleVehicleChange = (e) => {
    setSelectVehicleId(e.target.value);
  };

  const getOrderStatusData = async () => {
    const currentQueryDate = moment(selectedDate).format("YYYY-MM-DD");
    const BASE_URL = `${SERVER_URL}/api/trips/trips-combined-status/${user_id}?start_date=${currentQueryDate}&take=${pageSize}&skip=${
      (currentPage - 1) * pageSize
    }&vehicle_id=${selectVehicleId}&status=${status}&company_id=${companyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setStatusOrder(result.data);
      setStatusOrderLength(result.data.length);
    } else {
      setStatusOrder([]);
    }
  };

  useEffect(() => {
    const fecthDebounced = _.debounce(getOrderStatusData, 500);
    fecthDebounced();
    return () => {
      fecthDebounced.cancel();
    };
  }, [currentPage, pageSize, selectedDate, status, companyId, selectVehicleId]);

  useEffect(() => {
    setCurrentPage(1);
  }, [pageSize, selectedDate, companyId, status, selectVehicleId]);
  const handleRefreshClick = () => {
    setCompanyId("");
    setSelectVehicleId("");
    getOrderStatusData();
  };
  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const handleChange = (value) => {
    setStatus(value);
  };

  const companyTables =
    statusOrder &&
    statusOrder?.length > 0 &&
    statusOrder?.map((company, index) => (
      <div
        key={index}
        className="table-responsive govt-table trip-table"
        style={{
          border: "0.05px solid lightGray",
          width: "100%",
          marginTop: "20px",
        }}
        ref={(el) => (componentPDFRefs.current[index] = el)}
      >
        <table className="table-bordered table">
          {/* Main Trip Details Header */}
          <thead>
            <tr>
              <th
                colSpan={2}
                style={{
                  minWidth: "200px",
                  wordBreak: "break-word",
                }}
              >
                <span>Start Date: </span>
                {company.start_date}
              </th>
              <td>
                <span>Departure DateTime: </span>
                {company.departure_datetime}
              </td>
              <td colSpan={2}>
                <span>Start Location: </span>
                {company.start_location}
              </td>
              <td colSpan={2}>
                <span>Return Location: </span>
                {company.return_location}
              </td>
              <td>
                <span>End Date: </span>
                {company.end_date}
              </td>
              <td>
                <span>Return DateTime: </span>
                {company.return_datetime}
              </td>
              <td colSpan={2}>
                <span>Trip Status: </span>
                <span
                  className={
                    company.trip_status == "On-going"
                      ? "text-success"
                      : "text-secondary"
                  }
                >
                  {company.trip_status}
                </span>
              </td>
              <td>
                <span className="print_btn">
                  <i
                    className="mdi mdi-printer-eye"
                    style={{ fontSize: "25px" }}
                    onClick={() => generatePDF(index)}
                  ></i>
                </span>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <span>Vehicle Number: </span>
                {company.vehicle_number}
              </td>
              <td colSpan={2}>
                <span>Driver Name: </span>
                {company.driver_name}
              </td>
              <td colSpan={2}>
                <span>Total Expense: </span>
                {company.total_expense}
              </td>
              <td colSpan={2}>
                <span>Start Reading: </span>
                {company.start_reading}
              </td>
              <td>
                <span>Dist. Start to Loc.: </span>
                {company.dist_start_loc}
              </td>
              <td>
                <span>Location Reading: </span>
                {company.location_reading}
              </td>
              <td>
                <span>Dist. Loc. to Return.: </span>
                {company.dist_loc_return}
              </td>
              {/* <td colSpan={2}>
                <span>Dist. Loc. to Return: </span>
                {company.dist_loc_return}
              </td> */}
              <td>
                <span>Total Distance: </span>
                {company.total_distance}
              </td>
            </tr>

            <tr>
              <td colSpan={2}>
                <span>Refuel Place: </span>
                {company.refuel_place}
              </td>
              <td colSpan={2}>
                <span>Refuel Place Reading: </span>
                {company.reading_refuel_place}
              </td>
              <td colSpan={2}>
                <span>Diesel: </span>
                {company.diesel_ltr}
              </td>
              <td colSpan={2}>
                <span>Rate: </span>
                {company.rate}
              </td>
              <td>
                <span>Amount: </span>
                {company.amount}
              </td>
              <td colSpan={2}>
                <span>Running: </span>
                {company.running}
              </td>
              <td>
                <span>Average: </span>
                {company.average}
              </td>
            </tr>
            <tr>
              <td colSpan={12}>
                <span>Remarks: </span>
                {company.remarks}
              </td>
            </tr>
          </thead>

          {/* Dispatch Details Header and Unload Details */}
          {company?.dispatchDetails?.map((order, orderIndex) => (
            <React.Fragment key={orderIndex}>
              <thead>
                {/* <tr>
                <td colSpan={12} style={{ fontWeight: "bold" }}>
                  Dispatch Details: {order.commonDetails.dispatch_type}
                </td>
              </tr> */}
                <tr>
                  <td
                    colSpan={2}
                    style={{
                      width: "80px",
                      minWidth: "80px",
                      wordBreak: "break-word",
                    }}
                  >
                    <span>Dispatch Type: </span>
                    {order?.commonDetails?.dispatch_type || "-"}
                  </td>
                  <td
                    colSpan={3}
                    style={{ minWidth: "175px", wordBreak: "break-word" }}
                  >
                    <span>Order/Di Number: </span>
                    {order?.commonDetails?.order_number ||
                      order?.commonDetails?.di_number ||
                      "-"}
                  </td>
                  <td
                    colSpan={3}
                    style={{ minWidth: "175px", wordBreak: "break-word" }}
                  >
                    <span>RCA/PO Number: </span>
                    {order?.commonDetails?.rca_number ||
                      order?.commonDetails?.po_number ||
                      "-"}
                  </td>
                  <td
                    colSpan={2}
                    style={{ minWidth: "175px", wordBreak: "break-word" }}
                  >
                    <span>Party Name: </span>
                    {order?.commonDetails?.party_name || "-"}
                  </td>
                  {/* <td colSpan={2} style={{ minWidth: "75px" }}>
                    <span>Product/Material: </span>
                    {order.commonDetails.product_name ||
                      order.commonDetails.material_name ||
                      "-"}
                  </td> */}
                  <td style={{ minWidth: "75px" }}>
                    <span>GP Number: </span>
                    {order?.commonDetails?.gp_number || "-"}
                  </td>
                  <td style={{ minWidth: "75px" }}>
                    <span>Total Dispatch Qty: </span>
                    {order?.commonDetails?.total_dispatch_qty || 0}
                  </td>
                </tr>
                <tr>
                  <th>S.NO</th>
                  <th colSpan={2}>Product/Material</th>
                  <th colSpan={3}>Unload Location</th>
                  <th colSpan={2}>Unload Qty</th>
                  <th>Vehicle Reading</th>
                  <th colSpan={3}>Remarks</th>
                </tr>
              </thead>

              <tbody>
                {order.unload_details.map((detail, detailIndex) => (
                  <tr key={detailIndex}>
                    <td style={{ minWidth: "20px" }}>{detailIndex + 1}</td>
                    <td colSpan={2}>
                      {detail?.product_name || detail?.material_name || "-"}
                    </td>
                    <td colSpan={3}>{detail?.unload_destination}</td>
                    <td colSpan={2}>{detail?.unload_qty}</td>
                    <td>{detail?.vehicle_reading}</td>
                    <td colSpan={3}>{detail.remarks || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </React.Fragment>
          ))}
        </table>
      </div>
    ));

  return (
    <>
      {" "}
      <div className="card mt-4">
        <div className="card-body">
          <div>
            <div
              style={{
                justifyContent: "space-between",
                display: "flex",
              }}
            >
              <p className="card-title">Trips Status</p>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <select
                      className="form-control"
                      onChange={handleCompanyChange}
                      value={companyId} // Set the value of the dropdown to the companyId state
                    >
                      <option value="">Select Start Location</option>
                      {companyDetails?.map((item, id) => {
                        return (
                          <option
                            key={id}
                            value={item.id}
                          >{`${item.companyName}, ${item.location}`}</option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <select
                      className="form-control"
                      onChange={handleVehicleChange}
                      value={selectVehicleId}
                      id="vehicle_id"
                      name="vehicle_id"
                      required
                    >
                      <option value="">Select Vehicle (All)</option>
                      {vehicle &&
                        vehicle?.length > 0 &&
                        vehicle?.map((item, id) => {
                          return (
                            <option
                              value={item.id}
                              key={id}
                            >{`${item.vehicle_number}`}</option>
                          );
                        })}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <div className="d-flex border-md-right flex-grow-1  p-3 item justify-content-center">
                  <i
                    className={`mdi mdi-truck-cargo-container
                  menu-icon mr-4 icon-lg dashboard-icon`}
                  ></i>
                  <div className="d-flex flex-column justify-content-around">
                    <small className="mb-1 text-muted">Total Trips</small>
                    <h2>
                      <CountUp
                        end={totalRecords ? totalRecords : 0}
                        duration={2}
                        separator=","
                      />
                    </h2>
                  </div>
                </div>
              </div>

              {/* <div className="col-md-4">
                <div className="d-flex border-md-right flex-grow-1  p-3 item justify-content-center">
                  <i
                    className={`mdi 
                    mdi-invoice-text-remove
                  menu-icon mr-4 icon-lg text-secondary`}
                  ></i>
                  <div className="d-flex flex-column justify-content-around">
                    <small className="mb-1 text-muted">Inactive</small>
                    <h2>
                      <CountUp
                        end={govtCountData?.inactiveCount}
                        duration={2}
                        separator=","
                      />
                    </h2>
                  </div>
                </div>
              </div> */}
              <div className="col-md-4">
                <div className="d-flex border-md-right flex-grow-1  p-3 item justify-content-center">
                  <i
                    className={`mdi 
                    mdi-truck-delivery-outline
                  menu-icon mr-4 icon-lg text-success`}
                  ></i>
                  <div className="d-flex flex-column justify-content-around">
                    <small className="mb-1 text-muted">On-going</small>
                    <h2>
                      <CountUp
                        end={govtCountData?.ongoing}
                        duration={2}
                        separator=","
                      />
                    </h2>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex border-md-right flex-grow-1  p-3 item justify-content-center">
                  <i
                    className={`mdi 
                    mdi-truck-check
                  menu-icon mr-4 icon-lg text-secondary`}
                  ></i>
                  <div className="d-flex flex-column justify-content-around">
                    <small className="mb-1 text-muted">Completed</small>
                    <h2>
                      <CountUp
                        end={govtCountData?.completed}
                        duration={2}
                        separator=","
                      />
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card mt-3">
        <div className="card-body">
          <div className="search mb-3 mt-3">
            <div className="row justify-content-end">
              <div className="col-md-4">
                <div className="form-group">
                  <select
                    className="form-control"
                    onChange={(e) =>
                      handleChange(e.target.value === "" ? "" : e.target.value)
                    }
                    value={status} // Set the value of the dropdown to the status state
                  >
                    <option value="">Select Status (All)</option>
                    <option value="ongoing">On-going</option>
                    <option value="completed">Completed</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="status_heading">
            <div className="status_heading">
              <h5>
                Trip Dispatch Details As On & Before Date:{" "}
                {moment(selectedDate).format("DD-MM-YYYY")}
              </h5>
              <span>
                <button
                  className="btn btn-sm btn-light btn-icon-text border ml-2"
                  onClick={handleRefreshClick}
                >
                  Refresh
                  <i
                    className="mdi mdi-refresh"
                    style={{ height: "4px", width: "4px" }}
                  ></i>
                </button>
              </span>
            </div>
          </div>
          <div className="justify-content-end d-flex">
            <button
              className="btn btn-sm btn-primary print_btn"
              type="button"
              disabled={statusOrder && statusOrder?.length > 0 ? false : true}
              onClick={() => handlePrintBulk()}
            >
              Print All
              <i
                className="mdi mdi-printer-eye"
                style={{ fontSize: "20px" }}
              ></i>
            </button>
          </div>

          <div className="private-table-container" ref={bulkPDFRef}>
            {companyTables}
          </div>
          <div style={{ marginTop: "20px" }}>
            <Pagination
              currentPage={currentPage}
              totalRecords={totalRecords}
              pageSize={pageSize}
              totalPages={totalPages}
              startItem={startItem}
              endItem={endItem}
              onPageChange={onPageChange}
              onPageSizeChange={onPageSizeChange}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TripDispatchStatus;
